exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ef-cell-group-top-button[data-v-83ab6118] {\r\n  /* display: flex; \r\n  text-align: right; */\r\n\r\n  display: inline-block;\r\n  text-align: right;\n}\r\n\r\n", ""]);

// exports
